<section class="min-vh-100 overflow-hidden position-relative d-flex align-items-center pt-5 pt-md-0">
  <!-- BACKGROUND VIDEO -->
<img
  src="https://empirewebvideos.s3.us-east-1.amazonaws.com/Probabase_bolide/black-businesswoman-addressing-team-at-meeting-lo-2026-01-05-06-27-01-utc.jpg" 
  class="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
  alt="Hero image"
/>
  <!-- OVERLAY -->
  <div class="position-absolute top-0 start-0 w-100 h-100 z-2 bg-black bg-opacity-50"></div>

  <!-- CONTENT -->
  <div class="container position-relative z-3 py-5">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10 col-xl-9 text-center">

        <!-- TOP PILL / KICKER -->
        <div class="d-flex justify-content-center mb-3">
          <span class="hero-kicker badge rounded-pill px-3 py-2 fw-normal">
            {{ hero_data.kicker }}
          </span>
        </div>

        <!-- TITLE -->
        <h1 class="hero-title mb-3 text-dark">
          {{ hero_data.headline }}
          <span class="hero-title-accent text-dark">{{ hero_data.headline_accent }}</span>
        </h1>

        <!-- SUBTEXT -->
        <p class="hero-lead mx-auto mb-4 text-dark">
          {{ hero_data.sub_headline }}
        </p>

        <!-- BUTTONS -->
        <div class="d-flex flex-column flex-sm-row gap-3 justify-content-center align-items-center mb-5">
          <router-link
            to="/login"
            class="btn btn-primary hero-btn-primary"
          >
            {{ hero_data.btn_text }}
            <span class="ms-2">→</span>
          </router-link>

          <button
            type="button"
            class="btn btn-outline-light hero-btn-secondary"
          >
            <i class="bi bi-play-fill me-2"></i>
            {{ hero_data.demo_text }}
          </button>
        </div>

        <!-- STATS CARD (single wide card like screenshot) -->
        <div class="hero-stats-card mx-auto">
          <div class="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div class="card-body p-0">
              <div class="row g-0 row-cols-2 row-cols-md-4">

                <div
                  class="col text-center py-4 px-3 hero-stat-col"
                  v-for="(stat, idx) in hero_stats"
                  :key="stat.key"
                  :class="{ 'border-md-end': idx !== hero_stats.length - 1 }"
                >
                  <div class="hero-stat-value mb-1">
                    {{ stat.value }}
                  </div>
                  <div class="hero-stat-label">
                    {{ stat.label }}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <!-- /STATS CARD -->

      </div>
    </div>
  </div>
</section>